.heroHomeContainer {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.heroHomeContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../../assets/images/grid-inward.jpeg) center/cover no-repeat;
  filter: grayscale(100%);
  z-index: -1;
  background-position: center 3%;
}

.openingContainer {
  display: flex;
  justify-content: center;
}

.unlockContainer {
  display: none;
}

.openingParent {
  width: 692;
  top: 255px;
  left: 374px;
  gap: 5px;
  margin-top: 146px;
}

.openingImage {
  width: 149px;
  height: 170.546875px;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
}

.openingTextParent {
  font-weight: 300;
  font-size: 76px;
  line-height: 84px;
  letter-spacing: 3px;
  text-align: center;
}

.openingText {
  text-align: center;
  background: var(--gradient-silver);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  margin-top: 110px;
  margin-bottom: 0;
  font-family: "Denton Test", sans-serif;
  font-weight: 300;
  font-size: 76px;
  line-height: 84px;
  z-index: 1;
  position: relative;
}

.openingTextGold {
  text-align: center;
  background: var(--gradient-gold);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.openingDescription {
  font-family: "Inter", sans-serif;
  color: var(--text-color-2);
  font-weight: 200;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;
  margin: 32px 0;
}

@media (max-width: 990px) {
  .heroHomeContainer {
    min-height: unset;
  }
}

@media (max-width: 720px) {
  .openingParent {
    margin-top: 115px;
    width: 100%;
  }
  .openingImage {
    width: 110.95;
    height: 127;
    top: 130px;
  }
  .openingText {
    font-weight: 180;
    font-size: 36px;
    line-height: 39px;
    letter-spacing: 10%;
    text-align: center;
  }
  .openingDescription {
    margin: 4px 0 24px;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
}

@media (max-width: 600px) {
  .unlockContainer .openingText {
    margin-top: 20px;
    width: 370px;
    font-weight: 300;
  }
  .unlockContainer .openingDescription {
    margin: 18px 0 4px;
    background: var(--notification-gradient-grey);
    backdrop-filter: blur(4px);
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .hiddenOpeningContainer {
    display: none;
  }
  .unlockContainer {
    display: flex;
  }
  .unlockImage {
    width: 240px;
    display: flex;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 400px)  {
  .unlockContainer .openingText {
    width: 300px;
    font-size: 28px;
  }
}